import { t } from "@lingui/macro";
import { Select } from "@src/components/ui-kit";
import { fieldToSelectProps } from "@src/utils/forms/inputHelpers";
import { useStore } from "@src/utils/hooks";
import type { FieldState } from "formstate";
import { computed } from "mobx";
import { observer } from "mobx-react-lite";
import type { FC } from "react";

type Props = {
  field: FieldState<string | undefined>;
  companyId: string;
  showLabel?: boolean;
  asPortal?: boolean;
  isDisabled?: boolean;
};

export const BankAccountSelect: FC<Props> = observer(
  function BankAccountSelect({
    field,
    companyId,
    showLabel,
    asPortal,
    isDisabled,
  }) {
    const { workspaceStore } = useStore();

    const accountsOptions = computed(() => {
      return workspaceStore
        .getCompanyBankAccounts(companyId, field.value)
        .map(({ id, iban }) => ({
          value: id,
          label: iban,
        }));
    }).get();

    return (
      <Select
        label={showLabel ? t`Agency bank account` : undefined}
        {...fieldToSelectProps(field, accountsOptions)}
        isClearable
        asPortal={asPortal}
        isDisabled={isDisabled}
      />
    );
  },
);
